module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-zh-TW.dba60dad.jpg";